package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class PortfolioPieceQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    title: String,
    subtitle: String?,
    body: String,
    links: String?,
    images: String?,
    date_start: String?,
    date_end: String?,
    project_id: String?,
    step_id: String?,
    status: String,
    pinned: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(691_564_325, arrayOf("portfolio_piece"), driver, "PortfolioPiece.sq",
      "selectAll",
      "SELECT portfolio_piece.id, portfolio_piece.title, portfolio_piece.subtitle, portfolio_piece.body, portfolio_piece.links, portfolio_piece.images, portfolio_piece.date_start, portfolio_piece.date_end, portfolio_piece.project_id, portfolio_piece.step_id, portfolio_piece.status, portfolio_piece.pinned, portfolio_piece.order_index, portfolio_piece.created_at, portfolio_piece.updated_at, portfolio_piece.is_deleted, portfolio_piece.deleted_at, portfolio_piece.synced_at FROM portfolio_piece WHERE is_deleted = 0 ORDER BY pinned DESC, order_index, updated_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectAll(): Query<Portfolio_piece> = selectAll { id, title, subtitle, body, links,
      images, date_start, date_end, project_id, step_id, status, pinned, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece(
      id,
      title,
      subtitle,
      body,
      links,
      images,
      date_start,
      date_end,
      project_id,
      step_id,
      status,
      pinned,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    title: String,
    subtitle: String?,
    body: String,
    links: String?,
    images: String?,
    date_start: String?,
    date_end: String?,
    project_id: String?,
    step_id: String?,
    status: String,
    pinned: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectById(id: String): Query<Portfolio_piece> = selectById(id) { id_, title, subtitle,
      body, links, images, date_start, date_end, project_id, step_id, status, pinned, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece(
      id_,
      title,
      subtitle,
      body,
      links,
      images,
      date_start,
      date_end,
      project_id,
      step_id,
      status,
      pinned,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByProject(project_id: String?, mapper: (
    id: String,
    title: String,
    subtitle: String?,
    body: String,
    links: String?,
    images: String?,
    date_start: String?,
    date_end: String?,
    project_id: String?,
    step_id: String?,
    status: String,
    pinned: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByProjectQuery(project_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectByProject(project_id: String?): Query<Portfolio_piece> =
      selectByProject(project_id) { id, title, subtitle, body, links, images, date_start, date_end,
      project_id_, step_id, status, pinned, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Portfolio_piece(
      id,
      title,
      subtitle,
      body,
      links,
      images,
      date_start,
      date_end,
      project_id_,
      step_id,
      status,
      pinned,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    title: String,
    subtitle: String?,
    body: String,
    links: String?,
    images: String?,
    date_start: String?,
    date_end: String?,
    project_id: String?,
    step_id: String?,
    status: String,
    pinned: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_123_923_882, arrayOf("portfolio_piece"), driver, "PortfolioPiece.sq",
      "selectDirty",
      "SELECT portfolio_piece.id, portfolio_piece.title, portfolio_piece.subtitle, portfolio_piece.body, portfolio_piece.links, portfolio_piece.images, portfolio_piece.date_start, portfolio_piece.date_end, portfolio_piece.project_id, portfolio_piece.step_id, portfolio_piece.status, portfolio_piece.pinned, portfolio_piece.order_index, portfolio_piece.created_at, portfolio_piece.updated_at, portfolio_piece.is_deleted, portfolio_piece.deleted_at, portfolio_piece.synced_at FROM portfolio_piece WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectDirty(): Query<Portfolio_piece> = selectDirty { id, title, subtitle, body, links,
      images, date_start, date_end, project_id, step_id, status, pinned, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece(
      id,
      title,
      subtitle,
      body,
      links,
      images,
      date_start,
      date_end,
      project_id,
      step_id,
      status,
      pinned,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    title: String,
    subtitle: String?,
    body: String,
    links: String?,
    images: String?,
    date_start: String?,
    date_end: String?,
    project_id: String?,
    step_id: String?,
    status: String,
    pinned: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16),
      cursor.getLong(17)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Portfolio_piece> = selectByIdAnyState(id) { id_,
      title, subtitle, body, links, images, date_start, date_end, project_id, step_id, status,
      pinned, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece(
      id_,
      title,
      subtitle,
      body,
      links,
      images,
      date_start,
      date_end,
      project_id,
      step_id,
      status,
      pinned,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    title: String,
    subtitle: String?,
    body: String,
    links: String?,
    images: String?,
    date_start: String?,
    date_end: String?,
    project_id: String?,
    step_id: String?,
    status: String,
    pinned: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_228_251_801, """
        |INSERT INTO portfolio_piece(id, title, subtitle, body, links, images, date_start, date_end, project_id, step_id, status, pinned, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 15) {
          bindString(0, id)
          bindString(1, title)
          bindString(2, subtitle)
          bindString(3, body)
          bindString(4, links)
          bindString(5, images)
          bindString(6, date_start)
          bindString(7, date_end)
          bindString(8, project_id)
          bindString(9, step_id)
          bindString(10, status)
          bindLong(11, pinned)
          bindLong(12, order_index)
          bindLong(13, created_at)
          bindLong(14, updated_at)
        }
    notifyQueries(1_228_251_801) { emit ->
      emit("portfolio_piece")
    }
  }

  public fun update(
    title: String,
    subtitle: String?,
    body: String,
    links: String?,
    images: String?,
    date_start: String?,
    date_end: String?,
    project_id: String?,
    step_id: String?,
    status: String,
    pinned: Long,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_573_197_993, """
        |UPDATE portfolio_piece
        |SET title = ?, subtitle = ?, body = ?, links = ?, images = ?, date_start = ?, date_end = ?, project_id = ?, step_id = ?, status = ?, pinned = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 14) {
          bindString(0, title)
          bindString(1, subtitle)
          bindString(2, body)
          bindString(3, links)
          bindString(4, images)
          bindString(5, date_start)
          bindString(6, date_end)
          bindString(7, project_id)
          bindString(8, step_id)
          bindString(9, status)
          bindLong(10, pinned)
          bindLong(11, order_index)
          bindLong(12, updated_at)
          bindString(13, id)
        }
    notifyQueries(1_573_197_993) { emit ->
      emit("portfolio_piece")
    }
  }

  public fun setStatus(
    status: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_298_482_412,
        """UPDATE portfolio_piece SET status = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, status)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_298_482_412) { emit ->
      emit("portfolio_piece")
    }
  }

  public fun setPinned(
    pinned: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_394_147_590,
        """UPDATE portfolio_piece SET pinned = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, pinned)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_394_147_590) { emit ->
      emit("portfolio_piece")
    }
  }

  public fun reorder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_442_284_261,
        """UPDATE portfolio_piece SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_442_284_261) { emit ->
      emit("portfolio_piece")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_024_593_493,
        """UPDATE portfolio_piece SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_024_593_493) { emit ->
      emit("portfolio_piece")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-1_438_519_634,
        """UPDATE portfolio_piece SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_438_519_634) { emit ->
      emit("portfolio_piece")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-2_067_480_185,
        """UPDATE portfolio_piece SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-2_067_480_185) { emit ->
      emit("portfolio_piece")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-36_301_106,
        """SELECT portfolio_piece.id, portfolio_piece.title, portfolio_piece.subtitle, portfolio_piece.body, portfolio_piece.links, portfolio_piece.images, portfolio_piece.date_start, portfolio_piece.date_end, portfolio_piece.project_id, portfolio_piece.step_id, portfolio_piece.status, portfolio_piece.pinned, portfolio_piece.order_index, portfolio_piece.created_at, portfolio_piece.updated_at, portfolio_piece.is_deleted, portfolio_piece.deleted_at, portfolio_piece.synced_at FROM portfolio_piece WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PortfolioPiece.sq:selectById"
  }

  private inner class SelectByProjectQuery<out T : Any>(
    public val project_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT portfolio_piece.id, portfolio_piece.title, portfolio_piece.subtitle, portfolio_piece.body, portfolio_piece.links, portfolio_piece.images, portfolio_piece.date_start, portfolio_piece.date_end, portfolio_piece.project_id, portfolio_piece.step_id, portfolio_piece.status, portfolio_piece.pinned, portfolio_piece.order_index, portfolio_piece.created_at, portfolio_piece.updated_at, portfolio_piece.is_deleted, portfolio_piece.deleted_at, portfolio_piece.synced_at FROM portfolio_piece WHERE project_id ${ if (project_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY order_index""",
        mapper, 1) {
      bindString(0, project_id)
    }

    override fun toString(): String = "PortfolioPiece.sq:selectByProject"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-422_741_261,
        """SELECT portfolio_piece.id, portfolio_piece.title, portfolio_piece.subtitle, portfolio_piece.body, portfolio_piece.links, portfolio_piece.images, portfolio_piece.date_start, portfolio_piece.date_end, portfolio_piece.project_id, portfolio_piece.step_id, portfolio_piece.status, portfolio_piece.pinned, portfolio_piece.order_index, portfolio_piece.created_at, portfolio_piece.updated_at, portfolio_piece.is_deleted, portfolio_piece.deleted_at, portfolio_piece.synced_at FROM portfolio_piece WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PortfolioPiece.sq:selectByIdAnyState"
  }
}
